export default __webpack_public_path__ + "static/media/styled_file_download_icon.8c228b68.svg";